export const LoggedInFooter: React.FC = () => (
  <footer className="z-50 border-t border-gray-300 bg-white">
    <div className="mx-auto px-4">
      <div className="flex h-16 items-center justify-between text-xs text-gray-500">
        © Copyright {new Date().getFullYear()} All Rights Reserved
      </div>
    </div>
  </footer>
)
